import brandMark from '../assets/anotacripto-mark.svg'

/** Símbolo da logo aprovada do AnotaCripto, o mesmo do aplicativo.
 * A importação pelo Vite versiona a URL quando o desenho muda. */
export function BrandMark({ size = 'medium' }: { size?: 'small' | 'medium' | 'large' }) {
  return <span className={`brand-mark ${size}`} aria-hidden="true">
    <img src={brandMark} alt="" width="64" height="64" draggable={false}/>
  </span>
}

export function BrandLockup({ compact = false }: { compact?: boolean }) {
  return <span className={`brand-lockup ${compact ? 'compact' : ''}`.trim()} aria-label="AnotaCripto Admin">
    <BrandMark size={compact ? 'small' : 'medium'}/>
    <span className="brand-wordmark">AnotaCripto<small>ADMIN</small></span>
  </span>
}
